<template>
    <facet-template
        :title="'Selected Filters (' + filterCount + ')'"
        :expand-collapse="expandCollapse"
        v-bind="$attrs"
        hide-clear-link
        @clear="clearAll"
    >
        <b-container>
            <b-row>
                <b-col cols="12" class="p-0">
                    <selected-filter-pills
                        :value="value"
                        @input="filtersChanged"
                    />
                </b-col>
            </b-row>
            <b-row v-if="this.enabledSelectedFilter.length > 0">
                <b-col cols="12" class="p-0 pt-2">
                    <div class="d-flex ml-1">
                        <b-link
                            @click="clearAll"
                            class="clear-filter-link d-flex flex-column justify-content-center"
                        >
                            Clear All Filters
                        </b-link>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </facet-template>
</template>

<script>
import FacetTemplate from "./FacetTemplate";
import { BContainer, BRow, BCol } from "bootstrap-vue";
import SelectedFilterPills from "./SelectedFilterPills";
import selectedFilterMixin from "./mixins/selectedFilterMixin";
const startEvent = new CustomEvent("action-type", { detail: "clear-filters" });
export default {
    mixins: [selectedFilterMixin],
    components: { FacetTemplate, BContainer, BRow, BCol, SelectedFilterPills },

    props: {
        value: {
            type: Array,
            required: true,
        },
        expandCollapse: {
            type: Boolean,
            default: false,
            required: false,
        },
    },

    computed: {
        filterCount() {
            return this.enabledSelectedFilter.length;
        },
    },

    methods: {
        clearAll() {
            document.dispatchEvent(startEvent);
        },
        filtersChanged(newSelectedFilters) {
            this.$emit("input", newSelectedFilters);
        },
    },
};
</script>
